"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addStaticUpdateInfoToCertificates = void 0;

var shared_1 = require("../../shared");

var Plugin_1 = require("@skbkontur/plugin-js/lib/Plugin");
/**
 * Проверяем даты сертификатов, и расширяем ICertificateListItem информацией об обновлении сертификата.
 * @param items ICerificateListItem[]
 */


exports.addStaticUpdateInfoToCertificates = function (items, options) {
  return items.map(function (item) {
    var certificate = item.certificate,
        state = item.state; // пропускаем сертификаты, издателей которых нет в конфиге обновления

    if (options.issuers.includes(certificate.issuer()) === false) {
      return item;
    } // Получаем инфу для обновления истекающих сертификатов.


    if (options.expiringCerts.enabled && state === "Expiring"
    /* Expiring */
    ) {
        item.staticUpdateInfo = getStaticUpdateInfo(item, options.expiringCerts, shared_1.StaticUpdateType.Expiring);
      }
    /**
     * Получаем инфу для обновления сертификатов на ГОСТ 2001.
     * если сертификат на ГОСТ 2001 и при этом его срок действия истекает,
     * то будет предложено обновить его на ГОСТ 2012
     */


    if (options.oldGost2001Certs.enabled && certificate.publicKeyAlgorithm() === Plugin_1.PublicKeyAlgorithm.GOSTR410_2001) {
      item.staticUpdateInfo = getStaticUpdateInfo(item, options.oldGost2001Certs, shared_1.StaticUpdateType.OldGost2001);
    }

    return item;
  });
};

var getStaticUpdateInfo = function getStaticUpdateInfo(_a, _b, type) {
  var certificate = _a.certificate,
      hasDublicate = _a.hasDublicate;
  var urlTemplate = _b.urlTemplate,
      textBeforeUpdate = _b.textBeforeUpdate,
      textAfterUpdate = _b.textAfterUpdate,
      buttonText = _b.buttonText;
  var back = encodeURIComponent(window.location.href);
  var updateUrl = urlTemplate.replace('{{thumbprint}}', certificate.thumbprint()).replace('{{back}}', back);
  /**
   * Eсли сертификат имеет дубликат в списке, то мы считаем что это более новый сертификат и будем выводить перед кнопкой другой текст.
   */

  var textBeforeButton = hasDublicate ? textAfterUpdate : textBeforeUpdate;
  return {
    updateUrl: updateUrl,
    textBeforeButton: textBeforeButton,
    buttonText: buttonText,
    type: type
  };
};